// Role Constants
export const ROLES = {
  // Platform Level
  SUPER_ADMIN: "SUPER_ADMIN",

  // Tenant Level
  BUSINESS_OWNER: "BUSINESS_OWNER",

  // Store Level
  STORE_MANAGER: "STORE_MANAGER",
  PHARMACIST: "PHARMACIST",
  CASHIER: "CASHIER",
  BILLING_STAFF: "BILLING_STAFF",
  INVENTORY_STAFF: "INVENTORY_STAFF",
  VIEWER: "VIEWER",
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

// NOTE: ROLE_HIERARCHY is now defined in permissions.ts
// to keep role hierarchy and permissions together
